import { useContext } from "react";

import { useAdminFramerateProfilesApi } from "../../../api/useAdminFramerateProfilesApi";
import { FramerateProfileListingContext } from "../../../context/FramerateProfilesListingContext";
import { EditFramerateProfileFormInputs } from "./EditFramerateProfileForm";

export const useEditFramerateProfileForm = () => {
    const { updateFramerateProfile } = useAdminFramerateProfilesApi();
    const { update: updateFramerateProfileInContext } = useContext(FramerateProfileListingContext);

    const editFramerateProfile = async (itemId: string, inputs: EditFramerateProfileFormInputs) => {
        const name = inputs.name;

        const mappings = {
            23.98: inputs.framerate2398,
            29.97: inputs.framerate2997,
            24: inputs.framerate24,
            25: inputs.framerate25,
            30: inputs.framerate30,
            50: inputs.framerate50,
            59.94: inputs.framerate5994,
            60: inputs.framerate60,
            OTHER: inputs.framerateOther
        };

        await updateFramerateProfile({ id: itemId, ...inputs });

        updateFramerateProfileInContext({
            id: itemId,
            name,
            mappings,
            updatedDate: new Date(),
            isModified: true
        });
    };

    return {
        editFramerateProfile
    };
};
